export type PublicEvent = {
  id: string
  topic: string
  dateLabel: string
  dateISO: string
  timeLabel: string
  durationLabel: string
  location: 'En ligne' | 'Lyon Confluence'
  mode: 'online' | 'in-person'
}

// Créneaux repris du flyer novembre–décembre 2026 fourni par Léna Lahor,
// complétés par les horaires de fin indiqués sur Billetweb (1 h 15 par séance).
// Ne pas inventer de jauge : elle ne figure pas sur le flyer.
export const UPCOMING_EVENTS: PublicEvent[] = [
  {
    id: 'emotions-20261103-1215-online',
    topic: 'Comment accompagner les émotions de nos enfants ?',
    dateLabel: 'Mardi 3 novembre 2026',
    dateISO: '2026-11-03T12:15:00+01:00',
    timeLabel: '12 h 15',
    durationLabel: '1 h 15',
    location: 'En ligne',
    mode: 'online',
  },
  {
    id: 'emotions-20261103-1830-lyon',
    topic: 'Comment accompagner les émotions de nos enfants ?',
    dateLabel: 'Mardi 3 novembre 2026',
    dateISO: '2026-11-03T18:30:00+01:00',
    timeLabel: '18 h 30',
    durationLabel: '1 h 15',
    location: 'Lyon Confluence',
    mode: 'in-person',
  },
  {
    id: 'emotions-20261112-1215-online',
    topic: 'Comment accompagner les émotions de nos enfants ?',
    dateLabel: 'Jeudi 12 novembre 2026',
    dateISO: '2026-11-12T12:15:00+01:00',
    timeLabel: '12 h 15',
    durationLabel: '1 h 15',
    location: 'En ligne',
    mode: 'online',
  },
  {
    id: 'emotions-20261119-1215-online',
    topic: 'Comment accompagner les émotions de nos enfants ?',
    dateLabel: 'Jeudi 19 novembre 2026',
    dateISO: '2026-11-19T12:15:00+01:00',
    timeLabel: '12 h 15',
    durationLabel: '1 h 15',
    location: 'En ligne',
    mode: 'online',
  },
  {
    id: 'maman-sereine-20261124-1215-online',
    topic: 'Comment être une maman détendue et sereine ?',
    dateLabel: 'Mardi 24 novembre 2026',
    dateISO: '2026-11-24T12:15:00+01:00',
    timeLabel: '12 h 15',
    durationLabel: '1 h 15',
    location: 'En ligne',
    mode: 'online',
  },
  {
    id: 'maman-sereine-20261124-1830-lyon',
    topic: 'Comment être une maman détendue et sereine ?',
    dateLabel: 'Mardi 24 novembre 2026',
    dateISO: '2026-11-24T18:30:00+01:00',
    timeLabel: '18 h 30',
    durationLabel: '1 h 15',
    location: 'Lyon Confluence',
    mode: 'in-person',
  },
  {
    id: 'maman-sereine-20261126-1215-online',
    topic: 'Comment être une maman détendue et sereine ?',
    dateLabel: 'Jeudi 26 novembre 2026',
    dateISO: '2026-11-26T12:15:00+01:00',
    timeLabel: '12 h 15',
    durationLabel: '1 h 15',
    location: 'En ligne',
    mode: 'online',
  },
  {
    id: 'enfants-heureux-20261208-1215-online',
    topic: 'Comment élever des enfants heureux ?',
    dateLabel: 'Mardi 8 décembre 2026',
    dateISO: '2026-12-08T12:15:00+01:00',
    timeLabel: '12 h 15',
    durationLabel: '1 h 15',
    location: 'En ligne',
    mode: 'online',
  },
  {
    id: 'enfants-heureux-20261208-1830-lyon',
    topic: 'Comment élever des enfants heureux ?',
    dateLabel: 'Mardi 8 décembre 2026',
    dateISO: '2026-12-08T18:30:00+01:00',
    timeLabel: '18 h 30',
    durationLabel: '1 h 15',
    location: 'Lyon Confluence',
    mode: 'in-person',
  },
  {
    id: 'enfants-heureux-20261210-1215-online',
    topic: 'Comment élever des enfants heureux ?',
    dateLabel: 'Jeudi 10 décembre 2026',
    dateISO: '2026-12-10T12:15:00+01:00',
    timeLabel: '12 h 15',
    durationLabel: '1 h 15',
    location: 'En ligne',
    mode: 'online',
  },
]

// Descriptions transmises par Léna Lahor (reprises de Billetweb), utilisées sur la page
// et dans le balisage structuré. Une seule source, pour éviter toute divergence.
export const EVENT_TOPIC_DESCRIPTIONS: Record<string, string> = {
  'Comment accompagner les émotions de nos enfants ?':
    'Colère, peur, tristesse… Vous aurez enfin des clés simples pour comprendre ce qui se cache derrière chaque émotion de votre enfant — car derrière chaque émotion, il y a un besoin qui cherche à être entendu. Vous repartirez avec des techniques concrètes à vivre avec lui au quotidien, mais aussi avec des outils pour vous accompagner vous-même, car on ne peut donner à son enfant que ce qu’on s’autorise à vivre pour soi. Vous quitterez cette conférence plus sereine, avec des gestes simples à appliquer dès ce soir, et surtout, sans une once de culpabilité.',
  'Comment être une maman détendue et sereine ?':
    'Patiente ET impatiente, disponible ET débordée, douce ET irritée… Et si vous pouviez vous aimer entière, sans attendre d’être parfaite pour vous le permettre ? Vous aurez enfin le droit de déposer cette exigence qui vous pousse à tout gérer, tout donner, sans jamais souffler. Vous repartirez avec des clés concrètes pour prendre soin de vous sans culpabilité, et pour comprendre que non, vous n’êtes pas une mauvaise mère quand vous ne répondez pas à toutes les injonctions qu’on vous impose. Vous quitterez cette conférence plus légère, avec la certitude que votre valeur de mère ne se joue pas dans la perfection, mais dans la relation que vous construisez, imparfaite et bien réelle, avec votre enfant.',
  'Comment élever des enfants heureux ?':
    'Et si le plus important n’était pas qu’ils sachent bien lire, bien compter ou tout réussir, mais qu’ils sachent bien vivre — avec eux-mêmes et avec les autres ? Vous découvrirez les compétences humaines essentielles à transmettre à vos enfants pour qu’ils grandissent résilients, confiants et reliés à ce qu’ils ressentent, plutôt que performants et déconnectés d’eux-mêmes. Vous repartirez avec des outils concrets et simples à intégrer au quotidien — un rituel de gratitude, une façon de nourrir leur autonomie, une manière de développer leur empathie — pour les aider à trouver leurs propres ressources plutôt que de toujours compter sur vous. Vous quitterez cette conférence avec un nouveau regard sur ce qui fait vraiment un enfant épanoui : pas la performance, mais la conscience de soi, l’acceptation et la confiance construite pas à pas.',
}

// Visuel distinct par conférence : versions WebP et JPEG, 800 × 800 px, sous 50 Ko.
export const EVENT_TOPIC_IMAGES: Record<string, { src: string; alt: string }> = {
  'Comment accompagner les émotions de nos enfants ?': {
    src: '/images/conference-emotions-enfants.webp',
    alt: 'Une mère s’accroupit à hauteur de son jeune enfant pour l’écouter avec calme',
  },
  'Comment être une maman détendue et sereine ?': {
    src: '/images/conference-maman-sereine.webp',
    alt: 'Une mère prend un moment pour respirer et se recentrer dans son salon',
  },
  'Comment élever des enfants heureux ?': {
    src: '/images/conference-enfants-heureux.webp',
    alt: 'Deux enfants jouent ensemble sur un tapis pendant que leur mère les regarde avec douceur',
  },
}

// Présentation éditoriale de chaque conférence sur la page des événements :
// numéro, famille de sujet, mots-clés et accroche courte. La description
// complète reste dans EVENT_TOPIC_DESCRIPTIONS, dépliable au clic.
export type ConferencePresentation = {
  index: number
  category: string
  tags: string[]
  short: string
}

export const EVENT_TOPIC_PRESENTATIONS: Record<string, ConferencePresentation> = {
  'Comment accompagner les émotions de nos enfants ?': {
    index: 1,
    category: 'Parentalité',
    tags: ['Comprendre', 'Accompagner', 'Apaiser'],
    short:
      'Colère, peur, tristesse… Découvrez ce qui se cache derrière les émotions de votre enfant et repartez avec des outils concrets pour mieux l’accompagner au quotidien.',
  },
  'Comment être une maman détendue et sereine ?': {
    index: 2,
    category: 'Bien-être',
    tags: ['Respirer', 'Se recentrer', 'Se faire confiance'],
    short:
      'Apprenez à lâcher prise, à mieux gérer votre charge mentale et à retrouver un équilibre au quotidien, pour être pleinement présente auprès de vos enfants.',
  },
  'Comment élever des enfants heureux ?': {
    index: 3,
    category: 'Parentalité',
    tags: ['Écoute', 'Confiance', 'Épanouissement'],
    short:
      'Découvrez comment cultiver un environnement bienveillant, stimuler leur confiance en eux et leur donner les clés pour grandir sereinement, tout en restant vous-même.',
  },
}

export type ConferenceFaq = { question: string; answer: string }

// Questions propres à chaque thème, d'après les FAQ transmises par Léna.
// Les informations communes (durée, inscription, présence des enfants) restent
// regroupées dans la FAQ générale de la page.
export const EVENT_TOPIC_FAQS: Record<string, ConferenceFaq[]> = {
  'Comment accompagner les émotions de nos enfants ?': [
    {
      question: 'À qui s’adresse cette conférence ?',
      answer: 'Aux parents qui se sentent parfois démunis face aux émotions de leur enfant et souhaitent mieux comprendre ce qui se joue derrière la colère, la peur ou la tristesse, sans ajouter de pression à leur quotidien.',
    },
    {
      question: 'Vais-je repartir avec des pistes concrètes ?',
      answer: 'Oui. Vous découvrirez des repères pour mieux accueillir les émotions et des outils simples à essayer au quotidien, en tenant compte de votre enfant comme de ce que ces moments éveillent en vous.',
    },
  ],
  'Comment être une maman détendue et sereine ?': [
    {
      question: 'À qui s’adresse cette conférence ?',
      answer: 'Aux mamans qui en font beaucoup, s’en demandent encore davantage et se sentent parfois en décalage entre la mère qu’elles voudraient être et celle qu’elles sont réellement certains jours.',
    },
    {
      question: 'Avec quoi vais-je concrètement repartir ?',
      answer: 'Avec des pistes pour repérer ce qui vous empêche d’être plus sereine, vivre vos émotions avec davantage de douceur, poser vos limites sans vous juger et retrouver des moments d’apaisement dans votre quotidien.',
    },
  ],
  'Comment élever des enfants heureux ?': [
    {
      question: 'À qui s’adresse cette conférence ?',
      answer: 'Aux parents qui souhaitent aider leurs enfants à développer des compétences humaines comme la confiance en soi et l’empathie, et cherchent des repères concrets pour les accompagner au quotidien.',
    },
    {
      question: 'Quelles pistes concrètes seront abordées ?',
      answer: 'La conférence propose des idées simples à intégrer dans la vie de famille, autour de l’autonomie, de la gratitude et de l’empathie, pour soutenir l’épanouissement de l’enfant sans viser la perfection.',
    },
  ],
}

// Assemble la carte d'une conférence : accroche courte visible, description
// complète dépliable, avec des valeurs de repli si un thème n'est pas décrit.
export function conferencePresentation(topic: string, fallbackIndex: number): ConferencePresentation & { full: string } {
  const base = EVENT_TOPIC_PRESENTATIONS[topic]
  const fallback = 'Une conférence animée par Léna Lahor, suivie d’un temps d’échange avec les participants.'
  return {
    index: base?.index ?? fallbackIndex,
    category: base?.category ?? 'Parentalité',
    tags: base?.tags ?? [],
    short: base?.short ?? fallback,
    full: EVENT_TOPIC_DESCRIPTIONS[topic] ?? fallback,
  }
}

export const EVENT_PRICE_EUR = 15
export const MAX_EVENT_QUANTITY = 10

/* ───────────────────────────────────────────────────────────────
   OFFRE DE FIN D'ANNÉE
   Toutes les conférences programmées jusqu'au 31 décembre 2026 sont
   offertes : elles servent de premier contact avant un accompagnement.
   À partir de 2027, le tarif habituel s'applique de nouveau, sans
   modification du code : il suffit d'ajouter les nouveaux créneaux.
   ─────────────────────────────────────────────────────────────── */
export const EVENT_OFFER_ENDS_AT = '2026-12-31T23:59:59+01:00'
export const EVENT_OFFER_NOTE = 'Offerte exceptionnellement jusqu’au 31 décembre 2026'
export const EVENT_OFFER_BADGE = 'Offerte'

export function isEventFree(event: Pick<PublicEvent, 'dateISO'>) {
  const startsAt = Date.parse(event.dateISO)
  const offerEndsAt = Date.parse(EVENT_OFFER_ENDS_AT)
  return Number.isFinite(startsAt) && Number.isFinite(offerEndsAt) && startsAt <= offerEndsAt
}

export function eventTopics() {
  return Array.from(new Set(UPCOMING_EVENTS.map((event) => event.topic)))
}

export const BILLETWEB_URL = 'https://www.billetweb.fr/multi_event.php?user=292996'
export const EVENT_PAGE_URL = 'https://www.lena-lahor-coaching.fr/evenements'
export const EVENT_POSTER = 'https://www.lena-lahor-coaching.fr/images/flyer-conferences-novembre-decembre-2026.webp'
export const DEFAULT_IN_PERSON_EVENT_ADDRESS = 'Rue Denuzière, Lyon 2e, à côté de la boulangerie des 3V'
